import type React from 'react';
import { useState } from 'react';

import {
  COMMENT_DOWNLOADS_WORDS_PER_LINE,
  TRANSCRIPTION_DOWNLOADS_WORDS_PER_LINE,
} from '../../../constants/local_storage';
import ControlsModal from '../../../ui/controls_modal/controls_modal';
import CheckboxFieldWrapper from '../../../ui/forms/field_wrappers/checkbox/checkbox';
import TextFieldWrapper from '../../../ui/forms/field_wrappers/text/text';
import withContextItems from '../context_items_hoc';
import type {
  ContextItemsHocProps,
  ModalComponentProps,
} from '../modals_manager/types';

import styles from './transcriptions_edit_subtitles.module.css';

type Props = ContextItemsHocProps & ModalComponentProps;

export const WORD_COUNT_DEFAULT = '15';
const TranscriptionsSubtitlesModal: React.FC<Props> = (props) => {
  const [transcriptionsWordsPerLine, setTranscriptionsWordsPerLine] = useState(
    localStorage.getItem(TRANSCRIPTION_DOWNLOADS_WORDS_PER_LINE) ||
      WORD_COUNT_DEFAULT,
  );
  const [commentsWordsPerLine, setCommentsWordsPerLine] = useState(
    localStorage.getItem(COMMENT_DOWNLOADS_WORDS_PER_LINE) ||
      WORD_COUNT_DEFAULT,
  );
  const [isCommentsEnabled, setIsCommentsEnabled] = useState(
    Boolean(localStorage.getItem(COMMENT_DOWNLOADS_WORDS_PER_LINE)),
  );
  const [isTranscriptionsEnabled, setIsTranscriptionsEnabled] = useState(
    Boolean(localStorage.getItem(TRANSCRIPTION_DOWNLOADS_WORDS_PER_LINE)),
  );

  return (
    <ControlsModal
      headerText="Manage Subtitles"
      confirmButtonText="Save"
      variant="success"
      isOpen={props.isOpen}
      onCancel={props.onCancel}
      onConfirm={() => {
        localStorage.setItem(
          TRANSCRIPTION_DOWNLOADS_WORDS_PER_LINE,
          isTranscriptionsEnabled ? transcriptionsWordsPerLine : '',
        );

        localStorage.setItem(
          COMMENT_DOWNLOADS_WORDS_PER_LINE,
          isCommentsEnabled ? commentsWordsPerLine : '',
        );

        return props.onConfirm();
      }}
      isForm
    >
      <p>Apply to:</p>
      <CheckboxFieldWrapper
        labelWidth="194px"
        label="Transcription Downloads"
        value={isTranscriptionsEnabled}
        onChange={(value) => {
          setIsTranscriptionsEnabled(Boolean(value));
        }}
      />
      {isTranscriptionsEnabled ? (
        <TextFieldWrapper
          name="words_per_line_transcriptions"
          value={transcriptionsWordsPerLine}
          type="number"
          validations={{ minNumber: 1 }}
          label="Words per subtitle line"
          onChange={(value) => {
            setTranscriptionsWordsPerLine(value ?? '');
          }}
          inputClassName={styles.word_count_input}
          labelWidth="194px"
        />
      ) : null}
      <CheckboxFieldWrapper
        value={isCommentsEnabled}
        onChange={(value) => {
          setIsCommentsEnabled(Boolean(value));
        }}
        labelWidth="194px"
        label="Comment Downloads"
      />
      {isCommentsEnabled ? (
        <TextFieldWrapper
          name="words_per_line"
          value={commentsWordsPerLine}
          type="number"
          validations={{ minNumber: 1 }}
          label="Words per subtitle line"
          onChange={(value) => {
            setCommentsWordsPerLine(value ?? '');
          }}
          inputClassName={styles.word_count_input}
          labelWidth="194px"
        />
      ) : null}
    </ControlsModal>
  );
};

export default withContextItems(TranscriptionsSubtitlesModal);
